module.exports.OtherConstants = Object.freeze({

    EMPTY_GUID: "00000000-0000-0000-0000-000000000000"
});
